'use client';

import { useState } from 'react';
import CookieBannerModal from './CookieBannerModal';
import { CookieBannerProps } from '@/actions/cookie-banner/getCookieBannerData';
import { acceptCookies, hasAnsweredCookies } from '@/utils/cookieConsent';

const CookieBannerClient = ({
  cookieBannerData,
  initiallyOpen,
}: {
  cookieBannerData?: CookieBannerProps;
  initiallyOpen: boolean;
}) => {
  // Back/forward replays the cached server payload, which may predate the visitor's answer
  const [open, setOpen] = useState(
    () => initiallyOpen && (typeof document === 'undefined' || !hasAnsweredCookies()),
  );

  const handleAccepted = () => {
    const expiry = new Date();
    // Save the cookie for a month
    expiry.setTime(expiry.getTime() + 30 * 24 * 60 * 60 * 1000);
    acceptCookies(expiry);
    setOpen(false);
  };

  const handleDeclined = () => {
    setOpen(false);
    // Save the cookie only for this session
    // Use the default expiry (session)
    document.cookie = 'cookiePolicy=declined; path=/';
  };

  return (
    <CookieBannerModal
      open={open}
      handleAccepted={handleAccepted}
      handleDeclined={handleDeclined}
      cookieBannerData={cookieBannerData}
    />
  );
};

export default CookieBannerClient;
